import useAuthenticatedUserService from 'infrastructure/security/authentication/authenticatedUserService';
import { useAsyncValue } from 'framework/utils';
import { LoadingParams } from 'framework/list';
import { useNewProjectService } from 'domain/shared/newProject';
import { CommercialStateNotificationData, ProjectNotificationType } from './types';
import { NotificationItemProps } from 'infrastructure/notification/types';
import { NOTIFICATIONS_TYPES } from 'infrastructure/notification/constants';

const useCommercialStateNotifications = (
  component?: NotificationItemProps<CommercialStateNotificationData>['component'],
): NotificationItemProps<CommercialStateNotificationData>[] => {
  const { getUserAlias } = useAuthenticatedUserService();
  const { notificationsSearch } = useNewProjectService();
  const currentUserAlias = useAsyncValue(async () => getUserAlias());

  const searchCommercialStateNotification = async (
    requestParams: LoadingParams,
  ): Promise<CommercialStateNotificationData> => {
    const request = await notificationsSearch({
      ...requestParams,
      filter: {
        ...requestParams?.filter,
        recipientAlias: {
          eq: currentUserAlias,
        },
      },
    });
    const items = (request.result as ProjectNotificationType[]) || [];
    const total = request.totalElements ?? items.length;

    return { items, total };
  };

  if (!currentUserAlias) return [];

  return [
    {
      type: NOTIFICATIONS_TYPES.COMMERCIAL_STATE,
      autoUpdate: true,
      loadData: () => searchCommercialStateNotification({ pageNumber: 0, pageSize: 30 }),
      isVisible: (data: CommercialStateNotificationData) => (data?.total ?? 0) > 0,
      getCount: (data: CommercialStateNotificationData) => data?.total ?? 0,
      component: component ?? (() => null),
    },
  ];
};

export default useCommercialStateNotifications;
